// Mapping centralisé des rôles techniques vers libellés humains (FR)
// Source de vérité : enum role du modèle User côté API
export const ROLE_LABELS = {
    superAdmin: 'Super Administrateur',
    directeur: 'Directeur',
    superviseur: 'Superviseur',
    agent: 'Agent',
    comptable: 'Comptable',
    support: 'Support',
};

export const ROLE_COLORS = {
    superAdmin: 'red',
    directeur: 'volcano',
    superviseur: 'gold',
    agent: 'blue',
    comptable: 'green',
    support: 'geekblue',
};

export const getRoleLabel = (role) => ROLE_LABELS[role] || role || '—';
export const getRoleColor = (role) => ROLE_COLORS[role] || 'default';
